import * as React from "react";
import type { SVGProps } from "react";
const SvgInfoLines = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.333 4.001H1.999M10.667 12.001H2M14 8.001H2"
    />
  </svg>
);
export default SvgInfoLines;
